import { useMutation, useQueryClient } from 'react-query'
import { postJSON } from 'common/services/api'
import {
  STOCK_DISCREPANCIES_QUERY_KEY,
  RESOLVE_DISCREPANCY_URL
} from './queryConstants'
import useMixpanelEvent, { MixpanelEvents } from 'hooks/useMixpanelEvent'
import dayjs from 'dayjs'

type UseResolveDiscrepancyProps = {
  medicationName?: string
  stockRecordId?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

type ResolveDiscrepancyRequest = {
  stockRecordId: string
  resolve: 'YES'
  reason: string
}

export const useResolveDiscrepancy = ({
  medicationName,
  stockRecordId,
  onSuccess,
  onError
}: UseResolveDiscrepancyProps = {}) => {
  const queryClient = useQueryClient()
  const sendEvent = useMixpanelEvent()

  const mutation = useMutation(
    ({ stockRecordId, reason }: { stockRecordId: string; reason: string }) => {
      const requestBody: ResolveDiscrepancyRequest = {
        stockRecordId,
        resolve: 'YES',
        reason
      }

      return postJSON({
        url: RESOLVE_DISCREPANCY_URL,
        json: requestBody
      })
    },
    {
      onSuccess: (_, variables) => {
        if (medicationName) {
          sendEvent(MixpanelEvents.EMAR_V2_DISCREPANCY_CLOSED, {
            medicationName,
            stockRecordId: variables.stockRecordId,
            time: dayjs().toISOString()
          })
        }

        queryClient.invalidateQueries([STOCK_DISCREPANCIES_QUERY_KEY])
        onSuccess?.()
      },
      onError: (error) => {
        console.error('Error resolving discrepancy:', error)
        onError?.(error)
      }
    }
  )

  return {
    resolveDiscrepancy: mutation.mutateAsync,
    isLoading: mutation.isLoading
  }
}

export default useResolveDiscrepancy
